import React from "react";

export default function CardVimeo(props) {
  if (!props.src) {
    return null;
  }

  return (
    <div style={{ width: "400px" }}>
      <iframe
        title="video"
        src={props.src}
        width="400"
        height="300"
        frameBorder="0"
      />
    </div>
  );
}
